import pagesNames from "../../constants/pages-names";

const ourCommitmentsPageDataAr = {
    title : "التزاماتنا",
    headerImage : {
        name : "our-commitments-header-image.jpg",
        alt : "A man standing in front of sab logo",
    },
    gridOne : {
        rowOne : [
            {
                title : "التحول لعمليات خالية من الانبعاثات",
                subtitle : "يهدف اتفاق باريس بشأن تغير المناخ إلى الحد من زيادة درجة الحرارة العالمية دون درجتين مئويتين فوق مستويات ما قبل الحقبة الصناعية، ومواصلة الجهود الرامية إلى الحد من ارتفاع درجة الحرارة عند 1.5 درجة مئوية. ولتحقيق هذا الهدف على المدى الطويل، يجب على جميع البلدان أن تستهدف الوصول إلى الحياد الكربوني وتصفير انبعاثات الغازات الدفيئة خلال العقود الثلاثة القادمة. يُدرك بنك الأول أن معالجة قضايا تغير المناخ تمثل تحدياً عاجلاً ومعقداً، يتطلب تحولاً جوهرياً في الاقتصاد العالمي.",
                image : {
                    name : "transition-to-net-zero-card.jpg",
                    alt : "transtion to net zero"
                },
                button : {
                    text : "أقرأ المزيد",
                    path : pagesNames.transition,
                }
            },
            {
                title : "منتجات وخدمات مستدامة",
                subtitle : "تُبرز مبادراتنا في التمويل المستدام جهودنا المتواصلة لكي نكون السبّاقين دوماً، فقد كان الأول أول مؤسسة تمويل سعودية تطلق وديعة خضراء.",
                image : {
                    name : "sustainable-projects.jpg",
                    alt : "sustainable financing"
                },
                button : {
                    text : "أقرأ المزيد",
                    path : pagesNames.sustainableFinancing,
                }
            }
        ],
        rowTwo : [
            {
                title : "الطاقة والانبعاثات",
                subtitle : "ولدعم هدف الوصول إلى صافي انبعاثات صفرية في عمليات البنك التشغيلية بحلول العام 2035، تشمل مبادرات الأول للحد من استهلاك الطاقة استبدال الشاشات القديمة بشاشات الكريستال السائل LCD، وتركيب مستشعرات ضوئية لضمان إطفاء جميع الأضواء بعد ساعات العمل. كما تم توصيل جميع مصابيح البنك بأجهزة توقيت ضمن نظام إدارة المبنى للمساعدة في تقليل استخدام الكهرباء. وتساهم المواد المعاد تدويرها المستخدمة في الأرضيات، إلى جانب الجدران ذات العزل القوي، في تقليل التبادل الحراري بين الداخل والخارج لتقليل الحاجة إلى مكيفات الهواء.",
                button : {
                    text : "أقرأ المزيد",
                    path : pagesNames.emissions,
                },
                image : null
            },
            {
                title : "رؤية السعودية 2030",
                subtitle : "تم إطلاق رؤية السعودية 2030 في عام 2016، وهي بمثابة خارطة طريق تحدد الأهداف التنموية المستقبلية للبلاد",
                button : {
                    text : "أقرأ المزيد",
                    path : pagesNames.vision,
                },
                image : {
                    name : "vision.jpg",
                    alt : "Beautiful view for a city",
                }
            }
        ]
    },
    sectionTwo : {
        title : "مبادرة السعودية الخضراء",
        subtitle : "تكثف المملكة العربية السعودية جهودها المناخية من خلال زيادة نشر برامج التحول البيئي والطاقة، مثل مبادرة السعودية الخضراء ومبادرة الشرق الأوسط الأخضر. مبادرة السعودية الخضراء هي برنامج وطني تدعمه رؤية 2030، وتهدف إلى زيادة الغطاء النباتي للمملكة، والحفاظ على الحياة البحرية، وتعزيز التنوع البيولوجي، وتشجيع الأنشطة الاقتصادية المستدامة مثل السياحة البيئية.",
        button : {
            text : "أقرأ المزيد",
            path : pagesNames.saudiGreen,
        }
    },
    flexViewSection : [
        {
            image : {
                name : "img-2.jpg",
                alt : "Light Cross the trees",
            },
            title : "Social Impact",
            subtitle : "Play a leading role to shape an inclusive and diverse society, positively impacting our stakeholders",
            button : {
                text : "Read More",
                path : pagesNames.home
            }
        },
        {
            image : {
                name : "img-5.jpg",
                alt : "a person using a laptop",
            },
            title : "Overarching Goal",
            subtitle : "Commitment towards a high standard of governance, driving integrity and responsibility in all decision-making.",
            button : {
                text : "Read More",
                path : pagesNames.home
            }
        },
        {
            image : {
                name : "img-4.jpg",
                alt : "A woman helps a child",
            },
            title : "Sustainability in Our Operations",
            subtitle : "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim",
            button : {
                text : "Read More",
                path : pagesNames.home
            }
        },
    ]
}

export default ourCommitmentsPageDataAr;